const S18_LeafHeat = {
    "x_labels": [
        "ZY15DAP_1",
        "ZY15DAP_2",
        "ZY15DAP_3",
        "ZY12DAP_1",
        "ZY12DAP_2",
        "ZY12DAP_3",
        "ZY9DAP_1",
        "ZY9DAP_2",
        "ZY9DAP_3",
        "CA15DAP_1",
        "CA15DAP_2",
        "CA15DAP_3",
        "CA12DAP_1",
        "CA12DAP_2",
        "CA12DAP_3",
        "CA9DAP_1",
        "CA9DAP_2",
        "CA9DAP_3"
    ],
    "y_labels": [
        "ZY15DAP_1",
        "ZY15DAP_2",
        "ZY15DAP_3",
        "ZY12DAP_1",
        "ZY12DAP_2",
        "ZY12DAP_3",
        "ZY9DAP_1",
        "ZY9DAP_2",
        "ZY9DAP_3",
        "CA15DAP_1",
        "CA15DAP_2",
        "CA15DAP_3",
        "CA12DAP_1",
        "CA12DAP_2",
        "CA12DAP_3",
        "CA9DAP_1",
        "CA9DAP_2",
        "CA9DAP_3"
    ],
    "data": [
        [
            0,
            0,
            1.0
        ],
        [
            1,
            0,
            0.846
        ],
        [
            2,
            0,
            0.955
        ],
        [
            3,
            0,
            0.757
        ],
        [
            4,
            0,
            0.822
        ],
        [
            5,
            0,
            0.786
        ],
        [
            6,
            0,
            0.533
        ],
        [
            7,
            0,
            0.606
        ],
        [
            8,
            0,
            0.603
        ],
        [
            9,
            0,
            0.893
        ],
        [
            10,
            0,
            0.886
        ],
        [
            11,
            0,
            0.849
        ],
        [
            12,
            0,
            0.727
        ],
        [
            13,
            0,
            0.729
        ],
        [
            14,
            0,
            0.716
        ],
        [
            15,
            0,
            0.529
        ],
        [
            16,
            0,
            0.554
        ],
        [
            17,
            0,
            0.531
        ],
        [
            0,
            1,
            0.846
        ],
        [
            1,
            1,
            1.0
        ],
        [
            2,
            1,
            0.891
        ],
        [
            3,
            1,
            0.865
        ],
        [
            4,
            1,
            0.841
        ],
        [
            5,
            1,
            0.852
        ],
        [
            6,
            1,
            0.623
        ],
        [
            7,
            1,
            0.622
        ],
        [
            8,
            1,
            0.659
        ],
        [
            9,
            1,
            0.864
        ],
        [
            10,
            1,
            0.814
        ],
        [
            11,
            1,
            0.817
        ],
        [
            12,
            1,
            0.802
        ],
        [
            13,
            1,
            0.789
        ],
        [
            14,
            1,
            0.783
        ],
        [
            15,
            1,
            0.602
        ],
        [
            16,
            1,
            0.611
        ],
        [
            17,
            1,
            0.595
        ],
        [
            0,
            2,
            0.955
        ],
        [
            1,
            2,
            0.891
        ],
        [
            2,
            2,
            1.0
        ],
        [
            3,
            2,
            0.795
        ],
        [
            4,
            2,
            0.838
        ],
        [
            5,
            2,
            0.814
        ],
        [
            6,
            2,
            0.558
        ],
        [
            7,
            2,
            0.609
        ],
        [
            8,
            2,
            0.619
        ],
        [
            9,
            2,
            0.913
        ],
        [
            10,
            2,
            0.892
        ],
        [
            11,
            2,
            0.867
        ],
        [
            12,
            2,
            0.758
        ],
        [
            13,
            2,
            0.758
        ],
        [
            14,
            2,
            0.744
        ],
        [
            15,
            2,
            0.549
        ],
        [
            16,
            2,
            0.571
        ],
        [
            17,
            2,
            0.548
        ],
        [
            0,
            3,
            0.757
        ],
        [
            1,
            3,
            0.865
        ],
        [
            2,
            3,
            0.795
        ],
        [
            3,
            3,
            1.0
        ],
        [
            4,
            3,
            0.913
        ],
        [
            5,
            3,
            0.935
        ],
        [
            6,
            3,
            0.802
        ],
        [
            7,
            3,
            0.761
        ],
        [
            8,
            3,
            0.82
        ],
        [
            9,
            3,
            0.762
        ],
        [
            10,
            3,
            0.738
        ],
        [
            11,
            3,
            0.73
        ],
        [
            12,
            3,
            0.838
        ],
        [
            13,
            3,
            0.849
        ],
        [
            14,
            3,
            0.834
        ],
        [
            15,
            3,
            0.748
        ],
        [
            16,
            3,
            0.734
        ],
        [
            17,
            3,
            0.729
        ],
        [
            0,
            4,
            0.822
        ],
        [
            1,
            4,
            0.841
        ],
        [
            2,
            4,
            0.838
        ],
        [
            3,
            4,
            0.913
        ],
        [
            4,
            4,
            1.0
        ],
        [
            5,
            4,
            0.951
        ],
        [
            6,
            4,
            0.775
        ],
        [
            7,
            4,
            0.837
        ],
        [
            8,
            4,
            0.839
        ],
        [
            9,
            4,
            0.797
        ],
        [
            10,
            4,
            0.804
        ],
        [
            11,
            4,
            0.766
        ],
        [
            12,
            4,
            0.863
        ],
        [
            13,
            4,
            0.859
        ],
        [
            14,
            4,
            0.845
        ],
        [
            15,
            4,
            0.743
        ],
        [
            16,
            4,
            0.762
        ],
        [
            17,
            4,
            0.735
        ],
        [
            0,
            5,
            0.786
        ],
        [
            1,
            5,
            0.852
        ],
        [
            2,
            5,
            0.814
        ],
        [
            3,
            5,
            0.935
        ],
        [
            4,
            5,
            0.951
        ],
        [
            5,
            5,
            1.0
        ],
        [
            6,
            5,
            0.764
        ],
        [
            7,
            5,
            0.8
        ],
        [
            8,
            5,
            0.81
        ],
        [
            9,
            5,
            0.798
        ],
        [
            10,
            5,
            0.778
        ],
        [
            11,
            5,
            0.753
        ],
        [
            12,
            5,
            0.868
        ],
        [
            13,
            5,
            0.868
        ],
        [
            14,
            5,
            0.848
        ],
        [
            15,
            5,
            0.731
        ],
        [
            16,
            5,
            0.734
        ],
        [
            17,
            5,
            0.718
        ],
        [
            0,
            6,
            0.533
        ],
        [
            1,
            6,
            0.623
        ],
        [
            2,
            6,
            0.558
        ],
        [
            3,
            6,
            0.802
        ],
        [
            4,
            6,
            0.775
        ],
        [
            5,
            6,
            0.764
        ],
        [
            6,
            6,
            1.0
        ],
        [
            7,
            6,
            0.874
        ],
        [
            8,
            6,
            0.939
        ],
        [
            9,
            6,
            0.511
        ],
        [
            10,
            6,
            0.531
        ],
        [
            11,
            6,
            0.505
        ],
        [
            12,
            6,
            0.695
        ],
        [
            13,
            6,
            0.696
        ],
        [
            14,
            6,
            0.707
        ],
        [
            15,
            6,
            0.856
        ],
        [
            16,
            6,
            0.83
        ],
        [
            17,
            6,
            0.833
        ],
        [
            0,
            7,
            0.606
        ],
        [
            1,
            7,
            0.622
        ],
        [
            2,
            7,
            0.609
        ],
        [
            3,
            7,
            0.761
        ],
        [
            4,
            7,
            0.837
        ],
        [
            5,
            7,
            0.8
        ],
        [
            6,
            7,
            0.874
        ],
        [
            7,
            7,
            1.0
        ],
        [
            8,
            7,
            0.932
        ],
        [
            9,
            7,
            0.573
        ],
        [
            10,
            7,
            0.614
        ],
        [
            11,
            7,
            0.563
        ],
        [
            12,
            7,
            0.729
        ],
        [
            13,
            7,
            0.721
        ],
        [
            14,
            7,
            0.727
        ],
        [
            15,
            7,
            0.808
        ],
        [
            16,
            7,
            0.829
        ],
        [
            17,
            7,
            0.8
        ],
        [
            0,
            8,
            0.603
        ],
        [
            1,
            8,
            0.659
        ],
        [
            2,
            8,
            0.619
        ],
        [
            3,
            8,
            0.82
        ],
        [
            4,
            8,
            0.839
        ],
        [
            5,
            8,
            0.81
        ],
        [
            6,
            8,
            0.939
        ],
        [
            7,
            8,
            0.932
        ],
        [
            8,
            8,
            1.0
        ],
        [
            9,
            8,
            0.563
        ],
        [
            10,
            8,
            0.594
        ],
        [
            11,
            8,
            0.558
        ],
        [
            12,
            8,
            0.738
        ],
        [
            13,
            8,
            0.737
        ],
        [
            14,
            8,
            0.742
        ],
        [
            15,
            8,
            0.857
        ],
        [
            16,
            8,
            0.851
        ],
        [
            17,
            8,
            0.84
        ],
        [
            0,
            9,
            0.893
        ],
        [
            1,
            9,
            0.864
        ],
        [
            2,
            9,
            0.913
        ],
        [
            3,
            9,
            0.762
        ],
        [
            4,
            9,
            0.797
        ],
        [
            5,
            9,
            0.798
        ],
        [
            6,
            9,
            0.511
        ],
        [
            7,
            9,
            0.573
        ],
        [
            8,
            9,
            0.563
        ],
        [
            9,
            9,
            1.0
        ],
        [
            10,
            9,
            0.934
        ],
        [
            11,
            9,
            0.946
        ],
        [
            12,
            9,
            0.807
        ],
        [
            13,
            9,
            0.807
        ],
        [
            14,
            9,
            0.783
        ],
        [
            15,
            9,
            0.547
        ],
        [
            16,
            9,
            0.562
        ],
        [
            17,
            9,
            0.54
        ],
        [
            0,
            10,
            0.886
        ],
        [
            1,
            10,
            0.814
        ],
        [
            2,
            10,
            0.892
        ],
        [
            3,
            10,
            0.738
        ],
        [
            4,
            10,
            0.804
        ],
        [
            5,
            10,
            0.778
        ],
        [
            6,
            10,
            0.531
        ],
        [
            7,
            10,
            0.614
        ],
        [
            8,
            10,
            0.594
        ],
        [
            9,
            10,
            0.934
        ],
        [
            10,
            10,
            1.0
        ],
        [
            11,
            10,
            0.95
        ],
        [
            12,
            10,
            0.833
        ],
        [
            13,
            10,
            0.83
        ],
        [
            14,
            10,
            0.813
        ],
        [
            15,
            10,
            0.593
        ],
        [
            16,
            10,
            0.625
        ],
        [
            17,
            10,
            0.593
        ],
        [
            0,
            11,
            0.849
        ],
        [
            1,
            11,
            0.817
        ],
        [
            2,
            11,
            0.867
        ],
        [
            3,
            11,
            0.73
        ],
        [
            4,
            11,
            0.766
        ],
        [
            5,
            11,
            0.753
        ],
        [
            6,
            11,
            0.505
        ],
        [
            7,
            11,
            0.563
        ],
        [
            8,
            11,
            0.558
        ],
        [
            9,
            11,
            0.946
        ],
        [
            10,
            11,
            0.95
        ],
        [
            11,
            11,
            1.0
        ],
        [
            12,
            11,
            0.829
        ],
        [
            13,
            11,
            0.83
        ],
        [
            14,
            11,
            0.809
        ],
        [
            15,
            11,
            0.581
        ],
        [
            16,
            11,
            0.597
        ],
        [
            17,
            11,
            0.573
        ],
        [
            0,
            12,
            0.727
        ],
        [
            1,
            12,
            0.802
        ],
        [
            2,
            12,
            0.758
        ],
        [
            3,
            12,
            0.838
        ],
        [
            4,
            12,
            0.863
        ],
        [
            5,
            12,
            0.868
        ],
        [
            6,
            12,
            0.695
        ],
        [
            7,
            12,
            0.729
        ],
        [
            8,
            12,
            0.738
        ],
        [
            9,
            12,
            0.807
        ],
        [
            10,
            12,
            0.833
        ],
        [
            11,
            12,
            0.829
        ],
        [
            12,
            12,
            1.0
        ],
        [
            13,
            12,
            0.968
        ],
        [
            14,
            12,
            0.958
        ],
        [
            15,
            12,
            0.799
        ],
        [
            16,
            12,
            0.809
        ],
        [
            17,
            12,
            0.779
        ],
        [
            0,
            13,
            0.729
        ],
        [
            1,
            13,
            0.789
        ],
        [
            2,
            13,
            0.758
        ],
        [
            3,
            13,
            0.849
        ],
        [
            4,
            13,
            0.859
        ],
        [
            5,
            13,
            0.868
        ],
        [
            6,
            13,
            0.696
        ],
        [
            7,
            13,
            0.721
        ],
        [
            8,
            13,
            0.737
        ],
        [
            9,
            13,
            0.807
        ],
        [
            10,
            13,
            0.83
        ],
        [
            11,
            13,
            0.83
        ],
        [
            12,
            13,
            0.968
        ],
        [
            13,
            13,
            1.0
        ],
        [
            14,
            13,
            0.95
        ],
        [
            15,
            13,
            0.801
        ],
        [
            16,
            13,
            0.804
        ],
        [
            17,
            13,
            0.778
        ],
        [
            0,
            14,
            0.716
        ],
        [
            1,
            14,
            0.783
        ],
        [
            2,
            14,
            0.744
        ],
        [
            3,
            14,
            0.834
        ],
        [
            4,
            14,
            0.845
        ],
        [
            5,
            14,
            0.848
        ],
        [
            6,
            14,
            0.707
        ],
        [
            7,
            14,
            0.727
        ],
        [
            8,
            14,
            0.742
        ],
        [
            9,
            14,
            0.783
        ],
        [
            10,
            14,
            0.813
        ],
        [
            11,
            14,
            0.809
        ],
        [
            12,
            14,
            0.958
        ],
        [
            13,
            14,
            0.95
        ],
        [
            14,
            14,
            1.0
        ],
        [
            15,
            14,
            0.804
        ],
        [
            16,
            14,
            0.804
        ],
        [
            17,
            14,
            0.781
        ],
        [
            0,
            15,
            0.529
        ],
        [
            1,
            15,
            0.602
        ],
        [
            2,
            15,
            0.549
        ],
        [
            3,
            15,
            0.748
        ],
        [
            4,
            15,
            0.743
        ],
        [
            5,
            15,
            0.731
        ],
        [
            6,
            15,
            0.856
        ],
        [
            7,
            15,
            0.808
        ],
        [
            8,
            15,
            0.857
        ],
        [
            9,
            15,
            0.547
        ],
        [
            10,
            15,
            0.593
        ],
        [
            11,
            15,
            0.581
        ],
        [
            12,
            15,
            0.799
        ],
        [
            13,
            15,
            0.801
        ],
        [
            14,
            15,
            0.804
        ],
        [
            15,
            15,
            1.0
        ],
        [
            16,
            15,
            0.95
        ],
        [
            17,
            15,
            0.947
        ],
        [
            0,
            16,
            0.554
        ],
        [
            1,
            16,
            0.611
        ],
        [
            2,
            16,
            0.571
        ],
        [
            3,
            16,
            0.734
        ],
        [
            4,
            16,
            0.762
        ],
        [
            5,
            16,
            0.734
        ],
        [
            6,
            16,
            0.83
        ],
        [
            7,
            16,
            0.829
        ],
        [
            8,
            16,
            0.851
        ],
        [
            9,
            16,
            0.562
        ],
        [
            10,
            16,
            0.625
        ],
        [
            11,
            16,
            0.597
        ],
        [
            12,
            16,
            0.809
        ],
        [
            13,
            16,
            0.804
        ],
        [
            14,
            16,
            0.804
        ],
        [
            15,
            16,
            0.95
        ],
        [
            16,
            16,
            1.0
        ],
        [
            17,
            16,
            0.943
        ],
        [
            0,
            17,
            0.531
        ],
        [
            1,
            17,
            0.595
        ],
        [
            2,
            17,
            0.548
        ],
        [
            3,
            17,
            0.729
        ],
        [
            4,
            17,
            0.735
        ],
        [
            5,
            17,
            0.718
        ],
        [
            6,
            17,
            0.833
        ],
        [
            7,
            17,
            0.8
        ],
        [
            8,
            17,
            0.84
        ],
        [
            9,
            17,
            0.54
        ],
        [
            10,
            17,
            0.593
        ],
        [
            11,
            17,
            0.573
        ],
        [
            12,
            17,
            0.779
        ],
        [
            13,
            17,
            0.778
        ],
        [
            14,
            17,
            0.781
        ],
        [
            15,
            17,
            0.947
        ],
        [
            16,
            17,
            0.943
        ],
        [
            17,
            17,
            1.0
        ]
    ]
}

// 将二维数组扁平化为一维数组
const values = S18_LeafHeat.data.map(item => item[2]); // 提取值
const max = Math.max(...values);
const min = Math.min(...values);

console.log(`最大值: ${max}, 最小值: ${min}`);

export default S18_LeafHeat